module.exports = __webpack_public_path__ + "static/media/favicon.96755bc6.ico";